export default function registerRoleDisplayDirective(Vue) {
  const allowedRoles = ["销售", "SBG国家经理", "SBG区域经理", "商务助理"];
  Vue.directive("role-display", {
    bind(el, binding, vnode) {
      // 占位注释节点
      const comment = document.createComment("role-display");
      el.__role_display_comment = comment;

      const userRole = binding.value;
      if (!allowedRoles.includes(userRole)) {
        // 替换为注释节点
        if (el.parentNode) {
          el.parentNode.replaceChild(comment, el);
        }
      }
    },
    componentUpdated(el, binding, vnode) {
      const comment = el.__role_display_comment;

      // 角色有变化，需进行 DOM 替换
      const userRole = binding.value;
      if (!allowedRoles.includes(userRole)) {
        // 但如果已经被替换过就不用再替换
        if (el.parentNode) {
          el.parentNode.replaceChild(comment, el);
        }
      } else {
        // 恢复元素
        if (comment && comment.parentNode) {
          comment.parentNode.replaceChild(el, comment);
        }
      }
    },
  });
}
